import { useEffect, useRef, useState } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { HugTableProvider } from './contexts/hug-table-provider'

export type HugTableContainerProps = {
  className?: string
  children: React.ReactNode
}

/** Requires a flex-column parent with a bounded height. */
export const HugTableContainer = ({ className, children }: HugTableContainerProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [availableHeight, setAvailableHeight] = useState<number | null>(null)

  useEffect(() => {
    const parent = ref.current?.parentElement
    if (!parent) {
      return undefined
    }
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setAvailableHeight(entry.contentRect.height)
    })
    observer.observe(parent)
    return () => observer.disconnect()
  }, [])

  return (
    <HugTableProvider availableHeight={availableHeight}>
      <div
        ref={ref}
        className={cn(
          'flex min-h-0 flex-1 flex-col has-[[data-table-mode=hug]]:flex-none',
          className,
        )}
      >
        {children}
      </div>
    </HugTableProvider>
  )
}
